// @flow

import Time from '../constants/Time';

export default class Cookie {
  /**
   * Set the cookie
   */
  static set(name: string, value: string, seconds: number = Time.HALF_AN_HOUR_IN_SECONDS): void {
    const date: Date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    const expires: string = 'expires=' + date.toUTCString();

    let cookie: string = name + '=' + value + ';' + expires + ';path=/;samesite=lax';

    if (!window.store.environment.isLocal()) {
      cookie += ';secure=true';
    }

    document.cookie = cookie;
  }

  /**
   * Get the cookie with the given name
   */
  static get(pName: string): string {
    const name: string = pName + '=';
    const decodedCookie: string = decodeURIComponent(document.cookie);
    const cookies: Array<string> = decodedCookie.split(';');
    const cookiesLength: number = cookies.length;
    for (let i = 0; i < cookiesLength; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return '';
  }

  /**
   * Delete the cookie with the given name
   */
  static delete(pName: string) {
    this.set(pName, '', 0);
  }
}
